import { render, staticRenderFns } from "./externalSourceSettings.vue?vue&type=template&id=5c1cdca6"
import script from "./externalSourceSettings.vue?vue&type=script&lang=js"
export * from "./externalSourceSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports